import {FC, useContext, useEffect, useState} from 'react';
import {useRecoilState, useRecoilStateLoadable, useRecoilValue} from 'recoil';

import {Box, Drawer} from '@mui/material';
import {AddUserAccount} from './AddUserAccount';
import {EditUserAccount} from './EditUserAccount';
import Fallback from '../../../ui/fallback/Fallback';

import {userAccountControlModeState, userAccountControlState} from '../../../store/users/atoms';
import {userAccountByIdQuery} from '../../../store/users/selectors';
import {EventBusContext} from '../../../providers/EventBus';
import {IUserAccount} from '../../../shared/types/user-account.types';

const UserAccountControl: FC = () => {
  const mode = useRecoilValue(userAccountControlModeState);
  const [open, setOpen] = useRecoilState(userAccountControlState);
  const [{state, contents}, setUserAccount] = useRecoilStateLoadable(userAccountByIdQuery);
  const [loading, setLoading] = useState(false);
  const {bus} = useContext(EventBusContext);

  const handleClose = () => {
    !loading && setOpen(false);
  };

  useEffect(() => {
    state === 'hasValue' && setUserAccount(contents);

    state === 'hasError' && bus?.emit('error', [contents]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box sx={{width: '662px', p: 3}} role="presentation">
        {mode === 'ADD' ? (
          <AddUserAccount loading={loading} setLoading={setLoading} handleClose={handleClose} />
        ) : mode === 'EDIT' && state === 'hasValue' ? (
          <EditUserAccount
            account={contents as IUserAccount}
            loading={loading}
            setLoading={setLoading}
            handleClose={handleClose}
          />
        ) : (
          <Fallback />
        )}
      </Box>
    </Drawer>
  );
};

export default UserAccountControl;
